/**
 * A tape as a file on the pilot's disk.
 *
 * The original's tapes travelled: "you can copy the recorded missions to floppy
 * disk or transfer them by modem to your friends who have Red Baron" — an
 * asynchronous share-your-dogfight feature in 1990. A browser's version of the
 * same thing is a download and a file picker, and the shelf's `localStorage` is
 * only the convenient shelf, not the archive (`tape-store.ts`).
 *
 * The extension is `.tape.json`, never `.VCR`. It is not a `.VCR` and must not
 * be mistaken for one: an original tape cannot replay in this engine and one of
 * ours cannot replay in the original, because the integrators differ (AD-007a
 * is explicit that original-tape playback is not a goal). A file that claimed
 * the old extension would be an invitation to try.
 */

import { serializeTape, type ReplayTape } from "@red-opus/engine";

/**
 * Hands the tape to the browser as a download.
 *
 * The object URL is revoked on the next task rather than immediately: revoking
 * it in the same tick as the synthetic click races the download in some
 * browsers, and a leaked blob URL lives only as long as the document.
 */
export function downloadTape(tape: ReplayTape, fileName: string): void {
  const blob = new Blob([serializeTape(tape)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
